<template>
  <div class="FriendsList">
    <div class="contain" v-for="friend in friendsList" :key="friend.id">
      <div style="padding-left: 0.15rem; background: #ffffff">
        <div class="myFrient_content_top">
          <div class="myFrient_list_content">
            <div class="myFriends_title">
              <div class="myfriends_list_left">
                <div class="myFriebdpic">
                  <div class="myfriendsPhoto">
                    <img
                      :src="
                        friend.pic
                          ? friend.pic
                          : '../assets/img/personal/icon_portrait@2x.png'
                      "
                      alt=""
                      style="width: 0.51rem; height: 0.51rem"
                    />
                  </div>
                  <div class="picMark">
                    <div>{{ friend.group_name }}</div>
                  </div>
                </div>
                <div class="myFrient_list_title">
                  <div
                    style="
                      display: flex;
                      margin-bottom: 0.03rem;
                      align-items: center;
                    "
                  >
                    <div
                      style="
                        font-size: 0.14rem;
                        font-weight: bold;
                        color: #333333;
                      "
                    >
                      {{ friend.nickname ? friend.nickname : "--" }}
                    </div>
                    <div class="frined_agent" v-show="friend.region">
                      {{ friend.region ? friend.region : "--" }}
                    </div>
                  </div>
                  <div
                    style="
                      font-size: 0.14rem;
                      color: #333333;
                      margin-bottom: 0.03rem;
                    "
                  >
                    ID:{{ friend.id ? friend.id : "--" }}
                  </div>
                  <div
                    class="myFrient_list_time"
                    style="font-size: 0.12rem; color: #999a9c"
                  >
                    {{ friend.ctime ? friend.ctime : "--" }}
                  </div>
                </div>
              </div>
              <div class="myFriendsPhone" @click="callPhone(friend.username)">
                <img
                  src="../assets/img/personal/btn_call@2x.png"
                  alt=""
                  style="width: 0.12rem; height: 0.14rem"
                />
                <div>{{ friend.username }}</div>
              </div>
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="myFrient_content_bottom">
          <div>
            <p>订单数：{{ friend.my_order ? friend.my_order : "0" }}（个）</p>
            <p>客户数量：{{ friend.my_user ? friend.my_user : "0" }}（个）</p>
          </div>
          <div>
            <p>
              订单总额：{{
                friend.my_order_money ? friend.my_order_money : "0"
              }}
            </p>

            <p>
              客户订单：{{ friend.my_user_order ? friend.my_user_order : "0" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["friendsList"],
  methods: {
    // 调用拨号功能
    callPhone(phoneNumber) {
      window.location.href = "tel://" + phoneNumber;
    },
  },
};
</script>

<style lang='scss'>
.FriendsList {
  background: #f3f1f4;
  .contain {
    margin-top: 0.13rem;
    .myFrient_content_top {
      width: 100%;
      background: #ffffff;

      padding-top: 0.24rem;
      .myFrient_list_content {
        .myFriends_title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .myfriends_list_left {
            display: flex;
            .myFriebdpic {
              margin-right: 0.06rem;
              width: 0.6rem;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              // 类似于皇冠
              .picMark {
                position: absolute;
                bottom: 0.16rem;
                left: 0rem;
                width: 0.6rem;
                height: 0.18rem;
                background-image: url("../assets/img/personal/icon_grade_label_golden@2x.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 0.6rem 0.18rem;
                display: flex;
                flex-direction: column;
                align-items: center;

                div {
                  text-align: center;
                  color: #ffffff;
                  width: 200%;
                  transform: scale(0.5);
                  font-size: 0.16rem;
                  height: 0.16rem;
                  line-height: 0.16rem;
                }
              }
              .myfriendsPhoto {
                width: 0.51rem;
                height: 0.51rem;
                border-radius: 50%;
                overflow: hidden;
                margin-bottom: 0.24rem;
                position: relative;
              }
            }
            .myFrient_list_title {
              display: flex;
              flex-direction: column;
              .frined_agent {
                margin-left: 0.06rem;
                min-width: 0.7rem;
                height: 0.13rem;
                background: #f0ab16;
                border-radius: 0.02rem;
                line-height: 0.13rem;
                color: #ffffff;
                font-size: 0.1rem;
                text-align: center;
                padding: 0 0.05rem;
              }
            }
          }
          .myFriendsPhone {
            margin-right: 0.15rem;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              margin-right: 0.05rem;
            }
            div {
              font-size: 0.13rem;
              color: #333333;
            }
          }
        }
      }
    }
    .line {
      height: 0.01rem;
      background: #f3f1f4;
    }
    .myFrient_content_bottom {
      font-size: 0.14rem;
      color: #333333;
      padding-right: 0.62rem;
      display: flex;
      justify-content: space-between;
      padding: 0.19rem 0.62rem 0.19rem 0;
      div {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        p {
          height: 0.2rem;
          line-height: 0.2rem;
        }
        :first-child {
          margin-bottom: 0.12rem;
        }
      }
    }
  }
}
</style>